import get from 'lodash/get';
import merge from 'lodash/merge';
import clone from 'lodash/clone';
import keyBy from 'lodash/keyBy';
import unionBy from 'lodash/unionBy';
import mergeWith from 'lodash/mergeWith';
import values from 'lodash/values';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import assign from "lodash/assign";
import isEqual from "lodash/isEqual";

import {
  LOAD_CHAT_BY_ID_REQUEST_FAIL,
  LOAD_CHAT_BY_ID_REQUEST_START,
  LOAD_CHAT_BY_ID_REQUEST_SUCCESS,
  LOAD_CHATS_REQUEST_FAIL,
  LOAD_CHATS_REQUEST_START,
  LOAD_CHATS_REQUEST_SUCCESS,
  LOAD_MESSAGES_REQUEST_FAIL,
  LOAD_MESSAGES_REQUEST_START,
  LOAD_MESSAGES_REQUEST_SUCCESS,
  MERGE_CHATS,
  MERGE_MESSAGES,
  RECEIVE_MESSAGE,
  SET_ACTIVE_CHAT,
  UPDATE_ACTIVE_CHAT_DATA,
  SET_ACTIVE_CHAT_SCHEMA,
  SET_ALL_OLD_CHATS_LOADED,
  SET_ALL_OLD_MESSAGES_LOADED,
  SET_CHATS,
  SET_CHAT_FILTERS,
  UPDATE_CHAT_FILTERS,
  CLEAR_CHAT_FILTERS_KEY,
  SET_CHATS_VISIBLE_LIMIT,
  SET_MESSAGES,
  SET_MESSAGES_VISIBLE_LIMIT,
  VIEW_IMAGE_IN_MODAL,
  TOGGLE_MODAL_IN_CHAT,
  SET_WS_CONNECTED,
  UPDATE_CHAT_READ_TIME, UPDATE_CHAT_DATA,
  ADDING_NEW_CONTACT_TOGGLE_MODAL,
  ADDING_NEW_CONTACT_TOUCH_FORM,
  ADDING_NEW_CONTACT_REQUEST_START,
  ADDING_NEW_CONTACT_REQUEST_SUCCESS,
  ADDING_NEW_CONTACT_REQUEST_FAIL,
  IMPORT_NEW_CONTACTS_TOGGLE_MODAL,
  IMPORT_NEW_CONTACTS_TOUCH_FORM,
  IMPORT_NEW_CONTACTS_REQUEST_START,
  IMPORT_NEW_CONTACTS_REQUEST_SUCCESS,
  IMPORT_NEW_CONTACTS_REQUEST_FAIL,
  CHATS_CLEAR_DATA, SET_ACTIVE_CHAT_CHAT_WINDOW,
} from "../actions/Chats";
import moment from "moment";


const filterChats = (chats, chatFilters) => {
  return filter(
    chats,
    (chat) => !(
      (chatFilters.is_thread_open !== undefined && chatFilters.is_thread_open !== chat.is_thread_open)
      || (chatFilters.assigned_to_id !== undefined && chatFilters.assigned_to_id !== get(chat.assigned_to, 'id'))
    )
  )
};

const defaultState = {
  wsConnected: false,
  chats: undefined,
  activeChat: undefined,
  activeChatChatWindow: null,
  activeChatSchema: undefined,
  chatsRequestSending: false,
  chatsVisibleLimit: 20,
  allOldChatsLoaded: false,
  chatFilters: {},
  messages: [],
  messagesRequestSending: false,
  messagesVisibleLimit: 20,
  allOldMessagesLoaded: false,
  imageInChatViewed: '',
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_WS_CONNECTED:
      return {
        ...state,
        wsConnected: action.is_connected,
      };
    case SET_ACTIVE_CHAT_CHAT_WINDOW:
      let resultData = null
      if (action?.data?.status && action?.data?.status !== 'closed') {
        resultData = Math.floor((action?.data?.closeTime - Date.now()) / 36e5,)
        if (resultData < 0) resultData = 0
      } else if(action?.data?.status === 'closed'){
        resultData = 0;
      }
      return {
        ...state,
        activeChatChatWindow: resultData,
      };
    case SET_CHATS:
      action.chats.sort((left, right) => right.last_message_time - left.last_message_time);
      return {
        ...state,
        chats: cloneDeep(action.chats),
        // activeChat: undefined,
        allOldChatsLoaded: false,
        chatsVisibleLimit: 20,

        messages: [],
        allOldMessagesLoaded: false,
        messagesVisibleLimit: 20,
      };
    case SET_CHATS_VISIBLE_LIMIT:
      return {
        ...state,
        chatsVisibleLimit: action.limit,
      };
    case MERGE_CHATS:
      const actionChatsById = keyBy(action.chats, 'id');
      const stateChatsById = keyBy(state.chats, 'id');
      const resultChatsById = mergeWith(
        stateChatsById,
        actionChatsById,
      );

      const newChats = values(resultChatsById);
      newChats.sort((left, right) => right.last_message_time - left.last_message_time);

      return {
        ...state,
        chats: cloneDeep(newChats),
      };
    case SET_CHAT_FILTERS:
      return {
        ...state,
        chatFilters: cloneDeep(action.filters),
      };
    case UPDATE_CHAT_FILTERS:
      const updatedChatFilters = assign(clone(state.chatFilters), action.filtersToUpdate);

      if (!isEqual(updatedChatFilters, state.chatFilters)) {
        return {
          ...state,
          chatFilters: updatedChatFilters,
        }
      }
      return state;
    case CLEAR_CHAT_FILTERS_KEY:
      const clearedChatFilters = cloneDeep(state.chatFilters);
      delete clearedChatFilters[action.key];

      if (!isEqual(clearedChatFilters, state.chatFilters)) {
        return {
          ...state,
          chatFilters: clearedChatFilters,
        }
      }
      return state;
    case LOAD_CHATS_REQUEST_START:
      return {
        ...state,
        chatsRequestSending: true,
      };
    case LOAD_CHATS_REQUEST_SUCCESS:
      return {
        ...state,
        chatsRequestSending: false,
      };
    case LOAD_CHATS_REQUEST_FAIL:
      return {
        ...state,
        chatsRequestSending: false,
      };
    case LOAD_CHAT_BY_ID_REQUEST_START:
      return {
        ...state,
        chatByIdRequestSending: true,
      };
    case LOAD_CHAT_BY_ID_REQUEST_SUCCESS:
      return {
        ...state,
        chatByIdRequestSending: false,
      };
    case LOAD_CHAT_BY_ID_REQUEST_FAIL:
      return {
        ...state,
        chatByIdRequestSending: false,
      };
    case SET_ACTIVE_CHAT:
      let newActiveChat = action.chat;

      if (newActiveChat && get(newActiveChat, 'id') === get(state, 'activeChat.id') && !newActiveChat.store) {
        newActiveChat = merge(state.activeChat, newActiveChat)


      }
      return {
        ...state,
        activeChat: cloneDeep(newActiveChat),
        messages: [],
      };
    case UPDATE_CHAT_READ_TIME:

      let updatedChatsTime = cloneDeep(state.chats);
      if (action.chatId) {
        const idx = findIndex(updatedChatsTime, ['id', action.chatId]);
        if (idx !== -1) {
          updatedChatsTime[idx]['last_read_time'] = new Date().getTime() / 1000;
        }

      }
      return {
        ...state,
        chats: updatedChatsTime,
        messages: [],
      };
    case UPDATE_ACTIVE_CHAT_DATA:
      const updatedActiveChat = merge(cloneDeep(state.activeChat), action.data);

      let updatedChats = cloneDeep(state.chats);
      const idx = findIndex(updatedChats, ['id', updatedActiveChat.id]);
      if (idx !== -1) {
        updatedChats[idx] = updatedActiveChat;
      }

      updatedChats = filterChats(updatedChats, state.chatFilters);

      return {
        ...state,
        chats: updatedChats,
        activeChat: updatedActiveChat,
      };
    case UPDATE_CHAT_DATA:
      const chatToUpdateIndex = findIndex(state.chats, ['id', action.chat.id]);
      const updatedChatsInfo = cloneDeep(state.chats);
      const newChat = cloneDeep(action.chat);
      if (newChat.bot_user?.shop_id) {
        newChat['shop_id'] = newChat.bot_user.shop_id;
      }
      let updatedChat = {};
      if (chatToUpdateIndex !== -1) {
        const chatWithoutNulls = Object.fromEntries(Object.entries(newChat).filter(([_, v]) => v != null));
        updatedChat = merge(cloneDeep(state.chats[chatToUpdateIndex]), chatWithoutNulls);
        updatedChatsInfo[chatToUpdateIndex] = updatedChat;
      } else {
        updatedChat = newChat;
        if (updatedChatsInfo) {
          updatedChatsInfo.unshift(updatedChat);
        }
      }
      if (updatedChatsInfo) {
        updatedChatsInfo.sort((left, right) => right.last_message_time - left.last_message_time);
      }
      if (updatedChat.id === state.activeChat?.id) {
        return {
          ...state,
          chats: updatedChatsInfo,
          activeChat: updatedChat,
        };
      } else {
        return {
          ...state,
          chats: updatedChatsInfo,
        }
      }


    case SET_ACTIVE_CHAT_SCHEMA:
      return {
        ...state,
        activeChatSchema: cloneDeep(action.schema),
      };

    case SET_MESSAGES:
      const newMessages = cloneDeep(action.messages)
      newMessages.sort((left, right) => right.ts_in_messenger - left.ts_in_messenger)
      return {
        ...state,
        messages: newMessages,
        allOldMessagesLoaded: false,
        messagesVisibleLimit: 20,
      };
    case SET_MESSAGES_VISIBLE_LIMIT:
      return {
        ...state,
        messagesVisibleLimit: action.limit,
      };
    case VIEW_IMAGE_IN_MODAL:
      console.log('VIEW_IMAGE_IN_MODAL', action)

      return {
        ...state,
        imageInChatViewed: action.image
      };
    case TOGGLE_MODAL_IN_CHAT:
      console.log('TOGGLE_MODAL_IN_CHAT', action)
      return {
        ...state,
        imageInChatViewed: ''
      };
    case RECEIVE_MESSAGE:
      // Не делаем Deep - клонирование для быстроты работы

      //находим чат

      if (action.message.hasOwnProperty('chat')) {
        let updatedChatsTime = cloneDeep(state.chats);
        const idx = findIndex(updatedChatsTime, ['id', action.message.chat]);
        const currentTime = new Date().getTime() / 1000;
        if (idx !== -1) {
          if (action.message?.direction === 2) {
            updatedChatsTime[idx]['last_read_time'] = currentTime;
          }
          if (action.message?.direction === 1) {
            updatedChatsTime[idx]['last_message_time'] = currentTime;
          }
        }
        if (state.activeChat?.id === action.message.chat) {
          if (action.message?.direction === 1 && idx !== -1) {
            updatedChatsTime[idx]['last_read_time'] = currentTime + 1;
          }

          //если активный то проставляем сообщение
          const messages = clone(state.messages);
          const messageExistsIndex = findIndex(messages, ['id', action.message.id]);
          if (messageExistsIndex !== -1) {
            const prevStatus = messages[messageExistsIndex].status;

            messages[messageExistsIndex] = merge(cloneDeep(messages[messageExistsIndex]), action.message);
            messages[messageExistsIndex].status < prevStatus && (messages[messageExistsIndex].status = prevStatus);
          } else if (messages !== undefined) {

            messages.unshift(action.message);
          }
          if (updatedChatsTime) {
            updatedChatsTime.sort((left, right) => right.last_message_time - left.last_message_time);
          }
          return {
            ...state,
            messages,
            chats: updatedChatsTime,
          };
        } else {
          if (updatedChatsTime) {
            updatedChatsTime.sort((left, right) => right.last_message_time - left.last_message_time);
          }
          return {
            ...state,
            chats: updatedChatsTime,
          };
        }

      }


    case MERGE_MESSAGES:
      if (action.messages) {
        const newMessages = unionBy(action.messages, state.messages, (msg) => msg.id);
        newMessages.sort((left, right) => right.ts_in_messenger - left.ts_in_messenger)

        return {
          ...state,
          messages: newMessages,
        };
      } else {
        return {
          ...state
        }
      }
    case LOAD_MESSAGES_REQUEST_START:
      return {
        ...state,
        messagesRequestSending: true,
      };
    case LOAD_MESSAGES_REQUEST_SUCCESS:
      return {
        ...state,
        messagesRequestSending: false,
      };
    case LOAD_MESSAGES_REQUEST_FAIL:
      return {
        ...state,
        messagesRequestSending: false,
      };
    case SET_ALL_OLD_MESSAGES_LOADED:
      return {
        ...state,
        allOldMessagesLoaded: action.loaded,
      };
    case SET_ALL_OLD_CHATS_LOADED:
      return {
        ...state,
        allOldChatsLoaded: action.loaded,
      };
    case ADDING_NEW_CONTACT_TOGGLE_MODAL:
      return {
        ...state,
        addingNewContactStateModal: action.bool,
      };
    case ADDING_NEW_CONTACT_TOUCH_FORM:
      return {
        ...state,
        addingNewContactErrors: {},
      };
    case ADDING_NEW_CONTACT_REQUEST_START:
      return {
        ...state,
        addingNewContactLoading: true,
        addingNewContactErrors: {},
      };
    case ADDING_NEW_CONTACT_REQUEST_SUCCESS:
      return {
        ...state,
        addingNewContactLoading: false,
        addingNewContactData: action.data,
      };
    case ADDING_NEW_CONTACT_REQUEST_FAIL:
      return {
        ...state,
        addingNewContactLoading: false,
        addingNewContactData: undefined,
        addingNewContactErrors: action.errors,
      };
    case IMPORT_NEW_CONTACTS_TOGGLE_MODAL:
      return {
        ...state,
        importNewContactsStateModal: action.bool,
      };
    case IMPORT_NEW_CONTACTS_TOUCH_FORM:
      return {
        ...state,
        importNewContactsErrors: {},
      };
    case IMPORT_NEW_CONTACTS_REQUEST_START:
      return {
        ...state,
        importNewContactsLoading: true,
        importNewContactsErrors: {},
      };
    case IMPORT_NEW_CONTACTS_REQUEST_SUCCESS:
      return {
        ...state,
        importNewContactsLoading: false,
      };
    case IMPORT_NEW_CONTACTS_REQUEST_FAIL:
      return {
        ...state,
        importNewContactsLoading: false,
        importNewContactsErrors: action.errors,
      };
    case CHATS_CLEAR_DATA:
      return defaultState;
  }
  return state;
}
